/**
 * The one spelling of our own address.
 *
 * Cloudflare routes `www.ishavskraft.no` to the worker (`wrangler.toml`) and
 * redirects the apex here, so every place that *names* a page — canonical
 * link, sitemap entry, JSON-LD `@id` — has to agree on this string. When they
 * disagree, the same page gets several identities and search and answer
 * engines can't consolidate them.
 *
 * Not derived from the request origin: that would follow branch previews and
 * the pre-redirect apex host into metadata that is supposed to be stable.
 */
export const SITE_ORIGIN = "https://www.ishavskraft.no";

/**
 * Canonical absolute URL for a pathname.
 *
 * Query strings are dropped — they vary per visit (utm_*, session params) and
 * must never reach metadata that identifies the page.
 */
export const canonicalUrl = (pathname: string | null | undefined): string => {
	// Cloudflare's edge 307s a literal `:` in the path to `%3A`; name the URL it serves.
	const path = (pathname || "/").replaceAll(":", "%3A");
	return `${SITE_ORIGIN}${path.startsWith("/") ? path : `/${path}`}`;
};
